export * from './company-settings.component';
export * from './company-settings.trans';
